import { render, staticRenderFns } from "./NuovaTerapiaPaziente.vue?vue&type=template&id=0ba533df&"
import script from "./NuovaTerapiaPaziente.vue?vue&type=script&lang=js&"
export * from "./NuovaTerapiaPaziente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports